"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getAjvValidatorMw () {
        return getAjvValidatorMw;
    },
    get getApiTokenFromHeader () {
        return getApiTokenFromHeader;
    },
    get parseHrtimeToMilliSeconds () {
        return parseHrtimeToMilliSeconds;
    },
    get validatePayload () {
        return validatePayload;
    }
});
const _ajv = /*#__PURE__*/ _interop_require_default(require("ajv"));
const _ajvformats = /*#__PURE__*/ _interop_require_default(require("ajv-formats"));
const _catchError = require("~/helpers/catchError");
const _schema = /*#__PURE__*/ _interop_require_wildcard(require("~/schema"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function parseHrtimeToMilliSeconds(hrtime) {
    const milliseconds = (hrtime[0] * 1000 + hrtime[1] / 1e6).toFixed(3);
    return milliseconds;
}
const ajv = new _ajv.default({
    strictSchema: false,
    strict: false,
    allErrors: true
}); // Initialize AJV
ajv.addSchema(_schema.default, 'swagger.json');
ajv.addSchema(_schema.swaggerV3Validation, 'swagger-v3.json');
(0, _ajvformats.default)(ajv);
const getAjvValidatorMw = (schema)=>{
    return (req, res, next)=>{
        const validate = ajv.getSchema(schema);
        // Validate the request body against the schema
        const valid = validate(req.body);
        // If the request body is valid, call the next middleware
        if (valid) {
            next();
        } else {
            const errors = ajv.errors;
            // If the request body is invalid, send a response with an error message
            res.status(400).json({
                message: 'Invalid request body',
                errors
            });
        }
    };
};
const validatePayload = (schema, payload, humanReadableError = false, context = undefined)=>{
    const validate = ajv.getSchema(schema);
    if (!validate) {
        _catchError.NcError.get(context).genericNotFound('Validation schema', schema);
    }
    // Validate the request body against the schema
    const valid = validate(payload);
    // If the request body is not valid, throw error
    if (!valid) {
        const errors = ajv.errors || validate.errors;
        if (humanReadableError) {
        // let extractedSchema;
        // // extract schema from swagger json
        // if (schema.startsWith('swagger-v3.json#/components/schemas/')) {
        //   extractedSchema =
        //     swaggerV3.components.schemas[
        //       schema.split('swagger-v3.json#/components/schemas/')[1]
        //     ];
        // }
        // errors = betterAjvErrors({
        //   schema: validate.schema,
        //   data: payload,
        //   errors,
        // });
        }
        // If the request body is invalid, throw error with error message  and errors
        _catchError.NcError.get(context).ajvValidationError({
            message: 'Invalid request body',
            errors,
            humanReadableError
        });
    }
};
function getApiTokenFromHeader(req) {
    const headers = req == null ? void 0 : req.headers;
    if (!headers) return;
    // 1) Prefer explicit xc-token header
    const token = headers['xc-token'];
    if (typeof token === 'string' && token.trim()) {
        return token.trim();
    }
    // 2) Fallback to Authorization: Bearer <token>
    const auth = headers['authorization'];
    if (typeof auth !== 'string') return;
    const value = auth.trim();
    if (value.toLowerCase().startsWith('bearer ')) {
        return value.slice(7).trim();
    }
}
